import React, { useState } from "react";
import {
  FiHome,
  FiFileText,
  FiPlusCircle,
  FiMenu,
  FiX,
  FiLogOut,
  FiUser,
} from "react-icons/fi";
import { useLocation, useNavigate } from "react-router";
import { useAuth } from "../../context/AuthContext";
import LogoutConfirmationModal from "../logout-confirmation-modal/index";

const Sidebar = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { signOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { path: "/dashboard", label: "	Panel kontrolli", icon: FiHome },
    { path: "/add-post", label: "Shto Postimin", icon: FiPlusCircle },
    { path: "/posts", label: "Lista Postimeve", icon: FiFileText },
    { path: "/profile", label: "Profili", icon: FiUser },
  ];

  const handleTabClick = (path) => {
    setIsSidebarOpen(false);
    navigate(path);
  };

  const isActive = (path) => {
    if (path === "/dashboard" && location.pathname === "/") return true;
    if (path === "/posts" && location.pathname === "/postsList") return true;
    return location.pathname === path;
  };

  return (
    <>
      <div className="sm:block lg:hidden fixed top-5 right-5 z-50">
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className="p-2 bg-white rounded-full shadow-lg"
        >
          {isSidebarOpen ? (
            <FiX className="text-2xl text-gray-700" />
          ) : (
            <FiMenu className="text-2xl text-gray-700" />
          )}
        </button>
      </div>

      <div
        className={`absolute lg:relative top-0 left-0 h-full bg-white shadow-lg transition-transform duration-300 ease-in-out z-40 flex flex-col
          ${
            isSidebarOpen
              ? "translate-x-0 w-[70%] sm:w-[50%] md:w-[300px]"
              : "-translate-x-full"
          }
          lg:translate-x-0 lg:w-64`}
      >
        <div className="p-6 border-b">
          <h1 className="font-bold text-2xl text-gray-800">Balotazhi</h1>
          <p className="text-sm text-gray-500 mt-1">Paneli i Adminit</p>
        </div>

        <nav className="flex-1 p-4">
          <ul className="space-y-2">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const active = isActive(item.path);
              return (
                <li key={item.path}>
                  <button
                    className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200
                      ${
                        active
                          ? "bg-blue-50 text-blue-600 font-medium"
                          : "text-gray-700 hover:bg-gray-50 hover:text-gray-900"
                      }`}
                    onClick={() => handleTabClick(item.path)}
                  >
                    <Icon
                      className={`text-xl ${
                        active ? "text-blue-600" : "text-gray-500"
                      }`}
                    />
                    <span>{item.label}</span>
                  </button>
                </li>
              );
            })}
          </ul>
        </nav>

        <div className="p-4 border-t">
          <button
            className="w-full flex items-center gap-3 px-4 py-3 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
            onClick={() => setIsDialogOpen(true)}
          >
            <FiLogOut className="text-xl" />
            <span className="font-medium"> Dil nga llogaria</span>
          </button>
        </div>
      </div>

      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 lg:hidden"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      <LogoutConfirmationModal
        isOpen={isDialogOpen}
        isClosed={() => setIsDialogOpen(false)}
        onClose={() => setIsDialogOpen(false)}
        onConfirm={signOut}
      />
    </>
  );
};

export default Sidebar;
